import React from "react";
import "../styles/Termsofuse.css"; // Assuming the same stylesheet as Accessibility.js
import { Link } from "react-router-dom";

const Independent = () => {
  return (
    <div className="legal-wrapper">
      <main className="legal-main">
        <h1>Independent Contractor Agreement</h1>
        <p className="effective-date">Effective: January 15, 2020</p>

        <h3>1. Contractual Relationship</h3>
        <p>
          This Agreement ("Agreement") is made and entered into by and between
          ("DRIVER"), the undersigned contractor ("INDEPENDENT CONTRACTOR"), an
          independent contractor engaged in the business of performing the
          transportation services described by this Agreement, and BERYMO, Inc.
          ("BERYMO" or/and "BERYMO PLACES"). This Agreement will become effective
          on the date it is accepted regardless of whether you are eligible to, or
          ever do, perform any Contracted Services.
        </p>
        <p>
          <strong>
            IMPORTANT: PLEASE REVIEW THIS AGREEMENT CAREFULLY. BY ACCEPTING THIS
            AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD ALL OF THE
            TERMS AND HAVE TAKEN THE TIME AND SOUGHT ANY ASSISTANCE NEEDED TO
            COMPREHEND THE CONSEQUENCES OF ACCEPTING THIS AGREEMENT.
          </strong>
        </p>
        <p>
          BERYMO, INC. is a company which provides an online transportation
          marketplace that: Connects riders ("users," "customers"), drivers,
          partner places ("restaurants") (“if Partner Places”). BERYMO, Inc.'s
          software ("BERYMO MOBILE APP" and "BERYMO PLACES MOBILE APP") permits
          riders ("users", "customers") to schedule a ride ("transportation") to
          our partner places ("restaurants") for free (“if Partner Places”). Once a
          transportation request is made, BERYMO’s software notifies drivers that a
          ride opportunity is available and the BERYMO’s software facilitates
          completion of the ride. BERYMO is not a food delivery service or a
          restaurant or a transportation company.
        </p>
        <p>
          CONTRACTOR is an independent provider of transportation (“ride”)
          services, authorized to conduct the transportation services described by
          this Agreement in the geographic location(s) in which the CONTRACTOR
          operates. CONTRACTOR possesses all equipment and personnel necessary to
          perform the transportation services (such as a car) contemplated by this
          Agreement following applicable laws. CONTRACTOR desires to enter into
          this Agreement for the right to receive transportation opportunities made
          available through BERYMO, Inc.'s platform. CONTRACTOR understands and
          expressly agrees that he/she is not an employee of BERYMO or any
          restaurant, other business or consumer and that he/she is providing
          transportation services on behalf of him/herself and his/her business,
          not on behalf of BERYMO, Inc. CONTRACTOR understands: (i) he/she is free
          to select those times he/she wishes to be available on the platform to
          receive transportation opportunities; (ii) he/she is free to accept or
          reject the opportunities transmitted through the BERYMO or BERYMO PLACES
          (BERYMO, Inc. platform) by consumers, and can make such decisions to
          maximize his/her opportunity to profit; and (iii) he/she has the sole
          right to control the manner in which rides are performed and the means by
          which those rides are completed.
        </p>
        <p>
          In consideration of the above, as well as the mutual promises described
          herein, BERYMO, Inc. and CONTRACTOR ("the company," "driver") agree as
          follows:
        </p>

        <h3>2. Purpose of the Agreement</h3>
        <p>
          This Agreement governs the relationship between BERYMO, Inc. and
          CONTRACTOR and establishes the parties' respective rights and
          obligations. In exchange for the promises contained in this Agreement,
          CONTRACTOR shall have the right and obligation to perform the "Contracted
          Services" as defined herein. However, nothing in this Agreement requires
          CONTRACTOR to perform any particular volume of Contracted Services during
          the term of this Agreement, and nothing in this Agreement shall guarantee
          CONTRACTOR any particular volume of business for any particular time
          period.
        </p>
        <p>
          CONTRACTOR shall have no obligation to accept or perform any particular
          "Ride Opportunity" (as that term is defined herein) offered by BERYMO,
          Inc. However, once a Ride Opportunity is accepted, CONTRACTOR shall be
          contractually bound to complete the Contracted Services in accordance
          with all consumer specifications and the terms laid out in this
          Agreement.
        </p>

        <h3>3. Contractor's Operations</h3>
        <p>
          CONTRACTOR represents that he/she operates an independently established
          enterprise that provides transportation services, and that he/she
          satisfies all legal requirements necessary to perform the services
          contemplated by this Agreement. As an independent contractor/enterprise,
          CONTRACTOR shall be solely responsible for determining how to operate
          his/her business and how to perform the Contracted Services.
        </p>
        <p>
          CONTRACTOR agrees to fully perform the Contracted Services in a timely,
          efficient, safe, and lawful manner. BERYMO shall have no right to, and
          shall not, control the manner, method or means CONTRACTOR uses to perform
          the Contracted Services. Instead, CONTRACTOR shall be solely responsible
          for determining the most effective, efficient, and safe manner to perform
          the Contracted Services, including determining the manner of pickup, ride
          and route selection.
        </p>

        <h3>4. Contracted Services</h3>
        <p>
          From time to time, the BERYMO platform will notify CONTRACTOR of the
          opportunity to complete rides from:
          - Partner Places to riders in accordance with ride requests placed by
          riders through the BERYMO (“BERYMO PLACES”) platform.
          - Chosen Destination to riders in accordance with ride requests placed by
          riders through the BERYMO (“BERYMO”) platform.
          (each of these is referred to as a "Ride Opportunity"). For each Ride
          Opportunity accepted by CONTRACTOR ("Contracted Service"), CONTRACTOR
          agrees to transport the rider ("user," "customer") in a safe and timely
          manner and to/from the chosen partner place or a destination.
        </p>
        <p>
          CONTRACTOR understands and agrees that the parameters of each Contracted
          Service are established by the rider, not by the BERYMO, and represent
          the end result desired, not the means by which the CONTRACTOR is to
          accomplish the result. CONTRACTOR has the right to cancel, from time to
          time, a Contracted Service when, in the exercise of CONTRACTOR's
          reasonable discretion and business judgment, it is appropriate to do so.
        </p>
        <p>
          CONTRACTOR acknowledges that BERYMO has discretion as to which, if any,
          Ride Opportunity to offer, just as CONTRACTOR has the discretion whether
          and to what extent to accept any Ride Opportunity.
        </p>

        <h3>5. Relationship of Parties</h3>
        <p>
          The parties acknowledge and agree that this Agreement is between two
          co-equal, independent business enterprises that are separately owned and
          operated. The parties intend this Agreement to create the relationship of
          principal and independent contractor and not that of employer and
          employee. The parties are not employees, agents, joint venturers, or
          partners of each other for any purpose.
        </p>
        <p>
          BERYMO, Inc. shall not have the right to control the manner or the method
          of accomplishing Contracted Services to be performed by the CONTRACTOR.
          The parties acknowledge and agree that those provisions of the Agreement
          reserving ultimate authority in BERYMO, Inc. have been inserted solely
          for the safety of riders (“users”, “customers”) and other CONTRACTORS
          using the BERYMO, Inc. platform or to achieve compliance with federal,
          state, or local laws, regulations, and interpretations thereof.
        </p>
        <p>
          BERYMO, Inc. shall report all payments made to CONTRACTOR on a calendar
          year basis using an appropriate IRS Form 1099 if the volume of payments
          to CONTRACTOR qualify. CONTRACTOR agrees to report all such payments and
          any cash gratuities to the appropriate federal, state and local taxing
          authorities.
        </p>

        <h3>6. Payment for Services</h3>
        <p>
          Unless notified otherwise by BERYMO, Inc. in writing or except as
          provided herein, CONTRACTOR will receive payment per accurate Contracted
          Service completed in the amount listed in the payment schedule for the
          relevant market. From time to time, BERYMO, Inc. may offer opportunities
          for the CONTRACTOR to earn more money ("or bonus") for performing
          Contracted Services at specified times or in specified locations. Nothing
          prevents the parties from negotiating a different rate of pay, and
          CONTRACTOR is free to accept or deny any such opportunities to earn
          different rates of pay.
        </p>
        <p>
          BERYMO, Inc.'s online credit card software may permit riders to TIP THE
          CONTRACTOR (as a gift), and riders can also TIP THE CONTRACTOR in cash.
        </p>
        <p>
          - BERYMO PLACES APP, TIPS as a gift.
          - BERYMO APP, TIPS as a gift.
          CONTRACTOR shall retain 100% of the TIP paid by the rider if the TIP is
          for gift.
        </p>
        <p>
          BERYMO, Inc. will process payments made by riders and transmit to THE
          CONTRACTOR via direct deposit on a weekly basis unless it notifies THE
          CONTRACTOR otherwise in writing. THE CONTRACTOR will have the option to
          request an instant deposit if the CONTRACTOR earns minimum $5 by paying
          1.5% of the payout amount, with a minimum fee of 50¢ to our payment
          processor (Stripe, Inc.). Instant deposits will be deposited in a manner
          of minutes. If it is your first time using instant pay, you will be
          eligible to get paid instantly after 7 days of your first ride.
        </p>

        <h3>7. Equipment and Expenses</h3>
        <p>
          CONTRACTOR represents that he/she has or can lawfully acquire a vehicle,
          and is solely responsible for ensuring that the vehicle used conforms to
          all vehicle laws pertaining to safety, equipment, inspection, and
          operational capability.
        </p>
        <p>
          CONTRACTOR agrees that he/she is responsible for all costs and expenses
          arising from CONTRACTOR's performance of Contracted Services, including,
          but not limited to, costs related to CONTRACTOR's Personnel (defined
          below) and Equipment. Except as otherwise required by law, CONTRACTOR
          assumes all risk of damage or loss to its Equipment.
        </p>

        <h3>8. Insurance</h3>
        <p>
          CONTRACTOR agrees, as a condition of doing business with BERYMO, Inc.,
          that during the term of this Agreement, CONTRACTOR will maintain current
          insurance, in amounts and of types required by law to provide the
          Contracted Services, at his/her own expense. CONTRACTOR acknowledges that
          failure to secure or maintain adequate insurance coverage shall be deemed
          a material breach of this Agreement and shall result in the termination
          of the Agreement and the loss of CONTRACTOR's right to receive Ride
          Opportunities. CONTRACTOR agrees to provide updated certificates each time
          he/she changes the insurance.
        </p>
        <p>
          <strong>
            WORKERS' COMPENSATION/OCCUPATIONAL ACCIDENT INSURANCE: CONTRACTOR agrees
            that CONTRACTOR will not be eligible for workers' compensation benefits
            through BERYMO, Inc., and instead, will be responsible for providing
            CONTRACTOR's own workers' compensation insurance or occupational
            accident insurance, if permitted by law.
          </strong>
        </p>
        <p>
          When you are driving and involved in an accident, your own purchased
          insurance policy covers you and you are solely responsible.
        </p>

        <h3>9. Drugs and Alcohol</h3>
        <p>
          Berymo, Inc does not tolerate the use of drugs or alcohol by any driver
          while using the BERYMO, Inc.’s driver mobile application.
        </p>
        <p>
          Any driver found to be under the influence of alcohol or drugs while
          driving for BERYMO, Inc. (“BERYMO”, “BERYMO PLACES”, “BERYMO DRIVER”)
          will be permanently deactivated and will not be able to use our service.
        </p>

        <h3>10. Arbitration</h3>
        <p>
          Any and all controversies, disputes or claims arising out of or relating
          to this Agreement and its terms or a breach thereof shall be submitted to
          arbitration before a single arbitrator and in accordance with the
          Commercial Rules then obtained of the American Arbitration Association
          (“AAA”). The decision of the arbitrator shall be final and binding upon
          the parties, and judgment upon the award may be entered or enforced in
          any Court having jurisdiction thereof. All proceedings shall be
          maintained confidential by all parties involved.
        </p>
        <p>
          <strong>
            BY AGREEING TO THESE TERMS, YOU, AS A DRIVER (IF A DRIVERS), AGREES
            THAT YOU ARE REQUIRED TO BRING ANY CLAIMS AGAINST BERYMO, INC. ON AN
            INDIVIDUAL BASIS AND NOT AS A CLASS MEMBER, COLLECTIVE, REPRESENTATIVE
            ACTION OR PLAINTIFF AS AGREED UPON IN THIS ARBITRATION AGREEMENT. BY
            AGREEING TO THESE TERMS, YOU ARE ALSO OBLIGATED TO NOT PARTICIPATE IN
            ANY FUTURE CLASS OR CONSOLIDATED ACTION BROUGHT AGAINST BERYMO, INC. BY
            ANOTHER INDIVIDUAL.
          </strong>
        </p>
        <p>
          You and Berymo agree that any dispute, claim or controversy arising out
          of or relating to (a) these Terms or the existence, breach, termination,
          enforcement, interpretation or validity thereof, or (b) your access to or
          use of the Services at any time, whether before or after the date you
          agreed to the Terms, will be settled by binding arbitration between you
          and Berymo, and not in a court of law.
        </p>
        <p>
          You acknowledge and agree that you and Berymo are each waiving the right
          to a trial by jury or to participate as a plaintiff or class member in
          any purported class action or representative proceeding. Unless both you
          and Berymo otherwise agree in writing, any arbitration will be conducted
          only on an individual basis and not in a class, collective, consolidated,
          or representative proceeding. However, you and Berymo each retain the
          right to bring an individual action in small claims court and the right
          to seek injunctive or other equitable relief in a court of competent
          jurisdiction to prevent the actual or threatened infringement,
          misappropriation or violation of a party's copyrights, trademarks, trade
          secrets, patents or other intellectual property rights.
        </p>
      </main>
      <aside className="legal-sidebar">
        <ul>
          <li>
            <Link to="/Legal">Privacy Policy</Link>
          </li>
          <hr />
          <li>
            <Link to="/TermsofUse">Terms of Use</Link>
          </li>
          <hr />
          <li>
            <Link to="/Accessibility">Accessibility</Link>
          </li>
          <hr />
          <li>
            <Link to="/Independent" className="active">
              Independent Contractor Agreement
            </Link>
          </li>
          <hr />
          <li>
            <Link to="/PartnerPlacesAgreement">Partner Places Agreement</Link>
          </li>
          <hr />
        </ul>
      </aside>
    </div>
  );
};

export default Independent;

